import useBreakpoint from './useBreakpoint'

const useIsMobile = () => {
  // const breakpoint = useBreakpoint()
  // return ['sm', 'md'].includes(breakpoint)
  return false
}

export default useIsMobile
